import { render } from "./VerVenta.vue?vue&type=template&id=0fddd308&scoped=true"
import script from "./VerVenta.vue?vue&type=script&lang=js"
export * from "./VerVenta.vue?vue&type=script&lang=js"

import "./VerVenta.vue?vue&type=style&index=0&id=0fddd308&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fddd308"]])

export default __exports__